import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { useAppSelector } from '../../../reducers';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ShoppingCartQuantityPack = ({
  skuId,
  quantity,
  inline = true
}) => {
  const sku = useAppSelector(state => skuSelector(state, {
    skuId
  }));
  if (sku.skuType === QUANTITY_PACK) {
    const {
      quantityPackApiName
    } = sku;
    const message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: quantityPackApiName === 'additional-legacy-contacts' || quantityPackApiName === 'additional-marketing-contacts' ? 'planBuilder.shoppingCart.additionalContacts' : quantity === 1 ? 'planBuilder.shoppingCart.additionalUsers.one' : 'planBuilder.shoppingCart.additionalUsers.other',
      options: {
        count: quantity
      }
    });
    return inline ? message : /*#__PURE__*/_jsx("div", {
      children: message
    });
  } else {
    // This should never happen as ShoppingCartUnit is only used to render quantity packs
    Raven.captureMessage('Non-quantity pack SKU rendered in ShoppingCartQuantityPack', {
      extra: {
        skuId,
        skuType: sku.skuType,
        quantity
      }
    });
  }
  return null;
};
export default ShoppingCartQuantityPack;